module.exports = __webpack_public_path__ + "img/dalou_8_6.9982387e.png";